import { getRequestHeaders, handleRes, logError } from 'utils';
import {
  CreateViolationBody,
  PropertyViolation,
  Violation,
} from 'types/Violations';

export interface GetViolationsResponse extends Response {
  violations?: Array<Violation>;
}

export const getTenantViolations = (
  tenantID: number | string | undefined,
): Promise<Violation[]> => {
  return fetch(`${window.PROPERTY_BASE_URL}/tenant/${tenantID}/violations`, {
    method: 'GET',
    ...getRequestHeaders(),
  })
    .then((res) => handleRes<Violation[]>(res, 200))
    .catch((e) => {
      throw e;
    });
};

export const getTenantCustomViolations = (
  tenantID: number,
): Promise<Violation[]> => {
  return fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/violations/custom`,
    {
      method: 'GET',
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<Violation[]>(res, 200))
    .catch((e) => {
      throw e;
    });
};

export const getExcludedViolations = (
  tenantID: number,
): Promise<Violation[]> => {
  return fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/violations/excluded`,
    {
      method: 'GET',
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<Violation[]>(res, 200))
    .catch((e) => {
      throw e;
    });
};

export const excludeStandardViolation = async (
  tenantID: number,
  violationID: number,
): Promise<GetViolationsResponse> => {
  return await fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/violations/exclude/${violationID}`,
    {
      method: 'PUT',
      ...getRequestHeaders(),
    },
  );
};

export const includeStandardViolation = async (
  tenantID: number,
  violationID: number,
): Promise<GetViolationsResponse> => {
  return await fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/violations/include/${violationID}`,
    {
      method: 'PUT',
      ...getRequestHeaders(),
    },
  );
};

export const createTenantViolation = async (
  body: CreateViolationBody,
): Promise<GetViolationsResponse> => {
  return await fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${body.tenantID}/violations`,
    {
      method: 'POST',
      ...getRequestHeaders(),
      body: JSON.stringify(body),
    },
  );
};

export const updateTenantViolation = async (
  tenantID: number,
  body: Violation,
): Promise<GetViolationsResponse> => {
  return await fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/violations/${body.id}`,
    {
      method: 'PUT',
      ...getRequestHeaders(),
      body: JSON.stringify(body),
    },
  );
};

export const deleteTenantViolation = async (
  tenantID: number,
  violationID: number,
): Promise<GetViolationsResponse> => {
  return await fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/violations/${violationID}`,
    {
      method: 'DELETE',
      ...getRequestHeaders(),
    },
  );
};

export interface GetPropertyViolationsParams {
  propertyID: number;
  tenantID: number | string | undefined;
}
export const getPropertyViolations = async ({
  propertyID,
  tenantID,
}: GetPropertyViolationsParams): Promise<PropertyViolation[]> => {
  return await fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/properties/${propertyID}/activeViolations`,
    {
      method: 'GET',
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<PropertyViolation[]>(res, 200))
    .catch((e) => {
      logError(e);
      return [];
    });
};
